import { createApiClient } from 'commons/http/createApiClient';
import { config } from 'config';

// Commons (legacy - will be removed after BFF migration is complete)
const axiosInstance = createApiClient(config.api.commons);

export default axiosInstance;
